/**
 * Muscle Grenade — Reseñas de clientes (catálogo simulado)
 */
(function () {
  'use strict';

  if (window.__MG_REVIEWS_INIT__) return;
  window.__MG_REVIEWS_INIT__ = true;

  var DATA_URL = (window.MG_REVIEWS_DATA_URL || '').trim();
  if (!DATA_URL) {
    var el = document.querySelector('[data-mg-reviews-data]');
    if (el) DATA_URL = el.getAttribute('data-mg-reviews-data');
  }
  if (!DATA_URL) return;

  var cache = null;

  function starsHtml(value, max) {
    max = max || 5;
    var full = Math.floor(value);
    var half = value - full >= 0.5 ? 1 : 0;
    var empty = max - full - half;
    var decimal = half ? 0.5 : 0;
    return (
      '<div class="rating" role="img" aria-label="' + value + ' de ' + max + ' estrellas">' +
      '<span class="rating-star" style="--rating: ' + full + '; --rating-max: ' + max + '; --rating-decimal: ' + decimal + ';"></span>' +
      '</div>'
    );
  }

  function miniStars(n) {
    var s = '';
    for (var i = 0; i < 5; i++) s += i < n ? '★' : '☆';
    return s;
  }

  function getEntry(handle, data) {
    if (data[handle]) return data[handle];
    return data._default || null;
  }

  function fetchData() {
    if (cache) return Promise.resolve(cache);
    return fetch(DATA_URL)
      .then(function (r) { return r.json(); })
      .then(function (j) { cache = j; return j; })
      .catch(function () { return {}; });
  }

  function renderBadge(container, entry) {
    if (!container || !entry) return;
    container.innerHTML =
      starsHtml(entry.avg, 5) +
      '<p class="rating-count caption"><span aria-hidden="true">(' + entry.count + ')</span></p>' +
      '<span class="mg-reviews__badge" style="font-size:0.62rem;padding:0.15rem 0.45rem;">✓ Compra verificada</span>';
    container.hidden = false;
  }

  function renderSection(root, entry, productTitle) {
    if (!root || !entry) {
      root && root.classList.add('mg-reviews--empty');
      return;
    }

    var head = root.querySelector('[data-mg-reviews-head]');
    var list = root.querySelector('[data-mg-reviews-list]');
    if (!head || !list) return;

    head.innerHTML =
      '<h2 class="mg-reviews__title">Opiniones de <span>clientes</span></h2>' +
      '<div class="mg-reviews__summary">' +
      '<span class="mg-reviews__avg">' + entry.avg.toFixed(1) + '</span>' +
      starsHtml(entry.avg, 5) +
      '<p class="mg-reviews__count">Basado en ' + entry.count + ' opiniones</p>' +
      '<span class="mg-reviews__badge">✓ Compradores verificados MG</span>' +
      '</div>';

    list.innerHTML = entry.reviews.map(function (r) {
      return (
        '<article class="mg-reviews__card">' +
        '<div class="mg-reviews__card-top">' +
        '<div><p class="mg-reviews__author">' + r.name + '</p>' +
        '<p class="mg-reviews__meta">' + r.city + ', Chile · ' + r.date + '</p></div>' +
        '<span class="mg-reviews__stars" aria-label="' + r.stars + ' estrellas">' + miniStars(r.stars) + '</span>' +
        '</div>' +
        '<p class="mg-reviews__text">' + r.text + '</p>' +
        '<span class="mg-reviews__verified">' +
        '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M9 16.2 4.8 12l-1.4 1.4L9 19 21 7l-1.4-1.4z"/></svg>' +
        'Cliente verificado · ' + (productTitle || 'Muscle Grenade') +
        '</span></article>'
      );
    }).join('');
  }

  function init() {
    fetchData().then(function (data) {
      document.querySelectorAll('[data-mg-review-badge]').forEach(function (node) {
        var handle = node.getAttribute('data-mg-review-badge');
        renderBadge(node, getEntry(handle, data));
      });

      document.querySelectorAll('[data-mg-review-card]').forEach(function (node) {
        var handle = node.getAttribute('data-mg-review-card');
        var entry = getEntry(handle, data);
        if (!entry) return;
        node.innerHTML =
          '<div class="mg-review-badge mg-review-badge--card">' +
          starsHtml(entry.avg, 5) +
          '<p class="rating-count caption"><span>(' + entry.count + ')</span></p></div>';
      });

      document.querySelectorAll('[data-mg-reviews-section]').forEach(function (root) {
        var handle = root.getAttribute('data-product-handle');
        var title = root.getAttribute('data-product-title') || '';
        renderSection(root, getEntry(handle, data), title);
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();